<script setup lang="ts">
const emit = defineEmits(["submit"]);

const onSubmit = (event: Event) => {
  emit("submit", event);
};
</script>

<template>
  <!-- bootstrapVue の BForm において修飾子が動作しないため素の html タグを利用して BForm コンポーネントを上書きしている -->
  <form @submit="onSubmit">
    <slot />
  </form>
</template>
